<template>
  <v-flex
    :class="{
      'main-subscription': subscription.isMain,
      'main-subscription-border': subscription.isMain,
      'not-main-subscription': !subscription.isMain,
      'subscription-border': !subscription.isMain,
      'cursor-pointer': true,
      xs3: true,
      'mx-1': true,
      disabled: isDisabled,
    }"
  >
    <v-layout column fill-height>
      <v-flex xs12 fill-height>
        <v-layout row fill-height>
          <v-flex xs12 fill-height @click="goToPage(subscription.plan.name)">
            <div class="justify-space-between">
              <div>
                <div class="mt-3" v-if="subscription.isMain" style="text-align: center">
                  <v-chip style="margin-bottom: 0; margin-top: 2px" label color="#257439" text-color="white"
                    >Najczęściej wybierany
                  </v-chip>
                </div>
                <div class="plan-title my-3">
                  <SubscriptionTitle :title="subscription.plan.name" />
                </div>
                <div class="plan-description">{{ subscription.plan.description }}</div>
                <div class="pricing-container">
                  <div class="d-flex justify-content-center" v-if="!isDisabled">
                    <div class="plan-price">
                      {{ availableSubscriptions.length === 0 ? 0 : getMonthlyPrice(subscription.plan.name) }} zł
                    </div>
                    <div class="pl-3">
                      <span class="caption">brutto</span>
                      <br />
                      <span class="caption">miesięcznie</span>
                    </div>
                  </div>
                  <div class="font-weight-bold text-center" v-else-if="!isFree">Wybierz abonament na 6 lub 12 miesięcy</div>
                  <div class="text-center" v-if="!isDisabled">
                    Łącznie: {{ availableSubscriptions.length === 0 ? 0 : getGrosPrice(subscription.plan.name) }} zł
                    brutto <span v-if="!isFree">za {{ getMonthDuration }} {{ getFreeMonthLabel(selectedMonthDuration) }}</span>
                  </div>
                </div>
                <div class="free-month font-weight-bold">
                  <v-chip
                    small
                    color="#ffed00"
                    v-if="isAnnual && subscription.additionalMonthsForAnnualSubscription > 0"
                  >
                    + {{ subscription.additionalMonthsForAnnualSubscription }}
                    {{ getFreeMonthLabel(subscription.additionalMonthsForAnnualSubscription) }} gratis
                  </v-chip>
                  <v-chip
                    small
                    color="#ffed00"
                    v-if="isSemiAnnual && subscription.additionalMonthsForSemiAnnualSubscription > 0"
                  >
                    + {{ subscription.additionalMonthsForSemiAnnualSubscription }}
                    {{ getFreeMonthLabel(subscription.additionalMonthsForSemiAnnualSubscription) }} gratis
                  </v-chip>
                </div>
                <div class="functionalities">
                  <v-chip
                    class="functionalities-chip"
                    label
                    small
                    color="#257439"
                    text-color="white"
                    v-if="subscription.functionalities"
                  >
                    Wszystko co zawiera konto&nbsp;<span class="font-weight-bold">{{
                      subscription.functionalities
                    }}</span
                    >&nbsp;oraz:
                  </v-chip>
                </div>
                <v-list class="pros-list">
                  <template v-for="benefit in subscription.pros">
                    <v-list-tile class="tile-height">
                      <v-list-tile-action>
                        <v-icon color="success">check</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <div class="caption">{{ benefit }}</div>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                </v-list>
              </div>
              <div class="button-wrapper">
                <v-chip label color="#257439" text-color="white">Wybieram</v-chip>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import { polishPlurals } from 'polish-plurals';
import SubscriptionTitle from './SubscriptionTitle.vue';
import {
  DIETITIAN_FREE,
  DIETITIAN_PREMIUM,
  DIETITIAN_STANDARD,
  DIETITIAN_STUDENT,
  DIETITIAN_TEST
} from "../../utils/roles";
import {mapGetters} from "vuex";

export default {
  name: 'Subscription',
  components: {
    SubscriptionTitle,
  },
  props: {
    subscription: Object,
    current_user_subscription: Object,
    availableSubscriptions: Array,
    freeAccountUrl: String,
    selectedMonthDuration: Number,
    subscriptions: Object,
    had_paid_subscriptions: Boolean,
  },
  methods: {
    getMonthlyPrice(planName) {
      const currentSubscription = this.getCurrentSubscription(planName);

      return ((+currentSubscription.price / this.getDivider())).toFixed(2);
    },
    getGrosPrice(planName) {
      const currentSubscription = this.getCurrentSubscription(planName);

      return (+currentSubscription.price).toFixed(2);
    },
    goToPage(planName) {
      window.location.href = this.getUrl(planName);
    },
    getUrl(planName) {
      const currentSubscription = this.getCurrentSubscription(planName);
      if (!currentSubscription) {
        return this.freeAccountUrl;
      }

      return currentSubscription.url;
    },
    getCurrentSubscription(planName) {
      return this.availableSubscriptions.length === 1
        ? this.availableSubscriptions[0]
        : this.availableSubscriptions.find((availableSubscription) =>
            availableSubscription.name.toLowerCase().includes(planName.toLowerCase())
          );
    },
    getDivider() {
      let monthDuration = this.selectedMonthDuration;

      if (this.isAnnual) {
        monthDuration += this.subscription.additionalMonthsForAnnualSubscription;
      } else if (this.isSemiAnnual) {
        monthDuration += this.subscription.additionalMonthsForSemiAnnualSubscription;
      }

      return monthDuration;
    },
    getFreeMonthLabel(value) {
      return polishPlurals('miesiąc', 'miesiące', 'miesięcy', value);
    },
    isUpgradingSubscription(currentSubscription) {
      if (this.current_user_subscription === null) {
        return false;
      }

      if (this.current_user_subscription.subscription_type.role_to_assign === DIETITIAN_TEST) {
        return false;
      }

      if (currentSubscription && currentSubscription.id === 30) {
        return false;
      }

      let currentRole = null;
      if (this.current_user_subscription.subscription_type.id === 30) {
        currentRole = this.current_user_subscription.order.role_to_assign;
      } else {
        currentRole = this.current_user_subscription.subscription_type.role_to_assign;
      }

      const subscriptionsRoles = [DIETITIAN_STUDENT, DIETITIAN_STANDARD, DIETITIAN_PREMIUM];

      const newRole = currentSubscription.role_to_assign;
      const currentRoleIndex = subscriptionsRoles.indexOf(currentRole);
      const newRoleIndex = subscriptionsRoles.indexOf(newRole);
      return newRoleIndex > currentRoleIndex;
    },
    getMinSubscriptionDuration(currentSubscription) {
      if (
          this.isUpgradingSubscription(currentSubscription) &&
          this.current_user_subscription.subscription_type.role_to_assign !== DIETITIAN_TEST
      ) {
        const higherPriceSubscriptionsCount = Object.values(this.subscriptions)
            .filter((subscription) => {
              return subscription.role_to_assign === currentSubscription.role_to_assign;
            })
            .filter((subscription) => {
          return this.current_user_subscription.unused_days_value < Number(subscription.price);
        }).length;
        if (higherPriceSubscriptionsCount === 3) {
          return 30;
        } else if (higherPriceSubscriptionsCount === 2) {
          return 180;
        } else {
          return 365;
        }
      } else {
        return currentSubscription.role_to_assign === DIETITIAN_STUDENT ? 180 : 30;
      }
    },
  },
  computed: {
    ...mapGetters(['userRole']),
    isAnnual: function () {
      const currentSubscription = this.getCurrentSubscription(this.subscription.plan.name);

      return currentSubscription?.duration === 365;
    },
    isSemiAnnual() {
      const currentSubscription = this.getCurrentSubscription(this.subscription.plan.name);

      return currentSubscription?.duration === 180;
    },
    isDisabled() {
      if (this.isFree && this.had_paid_subscriptions) {
        return true;
      }

      if (this.isFree && this.userRole === DIETITIAN_FREE ) {
        return true;
      }

      const currentSubscription = this.getCurrentSubscription(this.subscription.plan.name);

      if (!currentSubscription) {
        return false;
      }

      const isUpgrading = this.isUpgradingSubscription(currentSubscription);
      if (isUpgrading && this.current_user_subscription.subscription_type.role_to_assign !== DIETITIAN_TEST) {
        const minDuration = this.getMinSubscriptionDuration(currentSubscription);
        if (currentSubscription.duration < minDuration) {
          this.$root.$emit('subscription-disabled', {isUpgrading})
          return true
        }
      }

      if ([365, 180].includes(currentSubscription.duration)) {
        return false;
      }

      return this.subscription.isAvailableMonthlySettlementPeriodType === false;
    },
    getMonthDuration() {
      return this.selectedMonthDuration;
    },
    isFree() {
      return this.subscription.id === 'free';
    }
  },
};
</script>

<style scoped>
.subscription-border {
  border: 1px solid #c1c1c1;
  border-radius: 10px;
}

.main-subscription-border {
  border: 1px solid #dadeda;
  border-radius: 20px;
}

.plan-description {
  min-height: 80px;
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.plan-price {
  font-size: 30px;
  text-align: right;
}

.pros-list {
  background: unset !important;
}

.not-main-subscription {
  margin-top: 30px;
  background: #f5f5f5;
}

.main-subscription {
  background: #e0f2e0;
}

.cursor-pointer {
  cursor: pointer;
}

.plan-title {
  text-align: center;
}

.free-month {
  min-height: 35px;
  display: flex;
  justify-content: center;
}

.functionalities {
  display: flex;
  justify-content: center;
  min-height: 30px;
}

.functionalities-chip {
  font-size: 10px;
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
  filter: grayscale(100%);
}

.pricing-container {
  min-height: 70px;
}

.v-chip__content {
  cursor: pointer !important;
}

.tile-height > .v-list__tile {
  min-height: 48px !important;
  height: unset !important;
}

.justify-space-between {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;
}
.button-wrapper {
  display: flex;
  justify-content: center;
}
>>> .v-list__tile {
  height: 100%;
  min-height: 32px;
}
</style>
